<div class="panel panel-primary">
  <div class="panel-heading">
    <ng-container *ngIf="title" [attr.data-testid]="'modal-title'">{{ title }}</ng-container>
  </div>
  <div class="panel-body" *ngIf="repParams && repParams.length > 0">
    <form class="form-horizontal" role="form" [formGroup]="reportForm">
      <div class="form-group" *ngFor="let param of repParams, let i=index">
        <div class="col-xs-5 col-sm-4">
          <label [attr.data-testid]="'report-form-' + param.type + '-input-label-'+ param.name + '-' + i" class="control-label">{{ param.label }}</label>
          <div *ngIf="param.type === 'date'" class="input-group">
            <input
              [attr.data-testid]="'report-form-' + param.type + '-input-' + param.name + '-' + i"
              type="text"
              class="form-control"
              [formControlName]="param.name"
              name="{{ param.name }}"
              [attr.required]="'true'"
              [attr.aria-required]="'true'"
              bsDatepicker
              [bsConfig]="{ containerClass: 'theme-red',  dateInputFormat: 'YYYY-MM-DD' }"
            />
          </div>
          <div *ngIf="param.type === 'select'" class="input-group">
            <div *ngIf="param.subtype === 'radio'">
              <div *ngFor="let option of param.options" class="form-check form-check-inline">
                <input [attr.data-testid]="'report-form-' + param.type + '-input-'+ param.name + '-' + i" type="radio" [value]="option" [formControlName]="param.name" class="form-check-input">
                <label [attr.data-testid]="'report-form-' + param.type + '-' + param.subtype + '-input-label-'+ param.name + '-' + option + '-' + i" class="form-check-label"> {{ option }}</label>
              </div>
            </div>
            <div *ngIf="param.subtype === 'checkbox'">
                <div *ngFor="let option of param.options" class="form-check form-check-inline">
                  <input [attr.data-testid]="'report-form-' + param.type + '-input-'+ param.name + '-' + i" type="checkbox" [value]="true" [formControlName]="param.name"  class="form-check-input">
                </div>
            </div>
            <div *ngIf="param.subtype === 'dropdown'">
              <div *ngIf="param.name === 'housename'">
                <div class="form-check form-check-inline">
                  <select [attr.data-testid]="'report-form-' + param.type + '-input-'+ param.name + '-' + i" [formControlName]="param.name" class="form-control">
                    <option *ngFor="let option of param.options" [attr.data-testid]="'report-form-' + param.type + '-' + param.subtype + '-input-options-'+ param.name + '-' + option + '-' + i" [value]="[option.ID, option.HouseName]">{{ option.HouseName }}</option>
                  </select>
                </div>
              </div>
              <div *ngIf="param.name != 'housename'">
                <div class="form-check form-check-inline">
                  <select [attr.data-testid]="'report-form-' + param.type + '-input-'+ param.name + '-' + i" [formControlName]="param.name" class="form-control">
                    <option *ngFor="let option of param.options" [attr.data-testid]="'report-form-' + param.type + '-' + param.subtype + '-input-options-'+ param.name + '-' + option + '-' + i" [value]="[option]">{{ option }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="param.type === 'text'" class="input-group">
            <input
              [attr.data-testid]="'report-form-' + param.type + '-input-'+ param.name + '-' + i"
              type="text"
              class="form-control"
              [formControlName]="param.name"
              *ngIf="param.subtype != 'number-input'"
            />
            <input
              [attr.data-testid]="'report-form-' + param.type + '-input-'+ param.name + '-' + i"
              type="number"
              class="form-control"
              [formControlName]="param.name"
              *ngIf="param.subtype === 'number-input'"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="panel-footer clearfix">
    <div>
      <button type="button" class="btn btn-danger" data-testid="cancel-button" (click)="cancelAction()">Cancel</button>
      <button type="button" class="btn btn-primary" data-testid="generate-report-button" (click)="generateReport()">Generate Report</button>
    </div>
  </div>
</div>
